/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expense_Filter_All_CategoriesInputs */

const vi_expense_filter_all_categories = /** @type {(inputs: Expense_Filter_All_CategoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tất cả danh mục`)
};

/**

* @param {Expense_Filter_All_CategoriesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const expense_filter_all_categories = /** @type {((inputs?: Expense_Filter_All_CategoriesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expense_Filter_All_CategoriesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_expense_filter_all_categories(inputs)
});